/**
 * Standard page-body-view this is the part below the navigation and the grey title area
 * Can show a list, title and a number of buttons
 */
'use strict'

var Marionette = require('marionette')
var App = require('app')
var _ = require('lodash')

var PageBodyLayoutView = Marionette.View.extend({
  template: require('./templates/layout.html'),
  events: {
    'click .js-button': 'onButtonClick'
  },
  onButtonClick: function (ev) {
    if (!ev.currentTarget) return false

    var button = ev.currentTarget
    var action = button.getAttribute('data-action')
    this.trigger(action, this)
    // console.log(action)
  },
  regions: {
    listRegion: {
      el: '.list-region',
      replaceElement: false
    }
  },
  templateContext: function () {
    var self = this
    return {
      getConditionalStr: App.TemplateHelpers.getConditionalStr,
      userHasRole: App.TemplateHelpers.userHasRole
    }
  }
})

module.exports.Layout = PageBodyLayoutView



// WEBPACK FOOTER //
// ./js/components/page-body-view/index.js